<template>
  <div v-if="visible" class="py-2 px-4 text-base">
    <div class="relative rounded-md bg-red-50 p-4">
      <div class="flex">
        <div class="flex-shrink-0">
          <icon set="solid" name="x-circle" class="h-5 w-5 text-red-400" />
        </div>
        <div class="ml-3 space-y-2">
          <h3 class="text-sm leading-5 font-medium text-red-800">
            <div class="whitespace-pre-wrap">{{ message }}</div>
          </h3>

          <div v-if="isValidationError" class="text-sm leading-5 text-red-700">
            <ul class="list-disc pl-5 space-y-1">
              <li
                v-for="(validationMessage, index) in validationErrors"
                :key="index"
              >
                {{ validationMessage }}
              </li>
            </ul>
          </div>

          <div
            v-if="uuid"
            class="flex items-center space-x-2 text-sm leading-5 text-red-800"
          >
            <span>Error ID:</span>
            <span class="relative">
              <span
                v-if="uuidIsCopiedToClipboard"
                class="absolute inset-0 text-red-500 text-center bg-red-100"
              >
                Copied to clipboard!
              </span>
              {{ uuid }}
            </span>
            <button
              type="button"
              class="focus:outline-none"
              v-if="canAccessClipboard"
              @click="copyToClipboard"
            >
              <icon
                :set="uuidIsCopiedToClipboard ? 'solid' : 'outline'"
                name="document-duplicate"
                class="h-5 w-5"
              />
            </button>
          </div>
        </div>
        <div v-if="dismissable" class="ml-auto pl-3">
          <div class="-mx-1.5 -my-1.5">
            <button
              type="button"
              class="
                inline-flex
                rounded-md
                p-1.5
                text-red-500
                hover:bg-red-100
                focus:outline-none focus:bg-red-100
                transition
                ease-in-out
                duration-150
              "
              aria-label="Dismiss"
              @click="visible = false"
            >
              <icon set="solid" name="x" class="h-5 w-5" />
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HttpError",
  props: {
    error: {
      type: Error,
    },
    dismissable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      visible: false,
      canAccessClipboard: false,
      uuidIsCopiedToClipboard: false,
    };
  },
  computed: {
    response() {
      return this.error?.response;
    },
    uuid() {
      return this.response?.data?.uuid;
    },
    message() {
      return this.response?.data?.message;
    },
    status() {
      return this.response?.status;
    },
    isValidationError() {
      return this.status == 422;
    },
    validationErrors() {
      let messages = [];

      for (let field in this.errors) {
        if (!Array.isArray(this.errors[field])) {
          continue;
        }

        messages = messages.concat(this.errors[field]);
      }

      return messages;
    },
    errors() {
      return this.response?.data?.errors;
    },
  },
  watch: {
    error() {
      this.visible = !!this.error;
    },
  },
  created() {
    this.visible = !!this.error;

    navigator.permissions
      .query({ name: "clipboard-write" })
      .then((result) => (this.canAccessClipboard = result.state === "granted"));
  },
  methods: {
    copyToClipboard() {
      navigator.clipboard
        .writeText(this.uuid)
        .then(() => this.highlightClipboard());
    },
    highlightClipboard() {
      this.uuidIsCopiedToClipboard = true;
      setTimeout(() => {
        this.uuidIsCopiedToClipboard = false;
      }, 1000);
    },
  },
};
</script>
